var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8052 67.6794C48.1341 67.4706 48.4931 67.3124 48.8662 67.2006C63.0115 62.9621 73.3197 49.8448 73.3197 34.32C73.3197 15.3656 57.9541 0 38.9997 0C20.0453 0 4.67969 15.3656 4.67969 34.32C4.67969 47.8227 12.4775 59.5042 23.8155 65.1068C23.8284 65.1132 23.8231 65.1326 23.8089 65.1315C23.7997 65.1308 23.7927 65.1396 23.7955 65.1483L26.9035 74.9903C27.6944 77.4949 30.6435 78.5705 32.8611 77.1631L47.8052 67.6794Z",
    fill: "#AF2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8137 27.6381C49.6421 26.8097 49.6421 25.4666 48.8137 24.6382L48.3622 24.1867C47.5338 23.3583 46.1907 23.3583 45.3623 24.1867L39.0002 30.5488L32.6381 24.1867C31.8097 23.3583 30.4666 23.3583 29.6382 24.1867L29.1867 24.6382C28.3583 25.4666 28.3583 26.8097 29.1867 27.6381L35.5488 34.0002L29.1867 40.3623C28.3583 41.1907 28.3583 42.5338 29.1867 43.3622L29.6382 43.8137C30.4666 44.6421 31.8097 44.6421 32.6381 43.8137L39.0002 37.4516L45.3623 43.8137C46.1907 44.6421 47.5338 44.6421 48.3622 43.8137L48.8137 43.3622C49.6421 42.5338 49.6421 41.1907 48.8137 40.3623L42.4516 34.0002L48.8137 27.6381Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.ba6224c5fe2cc148c3ad03ab97342470.svg";
export { ForwardRef as ReactComponent };